import Login from './Login';
import { withReferrerStatusMessaging } from './withReferrerStatusMessaging';

const LoginWithReferrerStatusMessaging = withReferrerStatusMessaging(Login);

export {
    LoginWithReferrerStatusMessaging as default,
    Login
};
